import { useCallback, useMemo } from 'react';
import classNames from 'classnames';

import { withHoverIcon } from '../../../hoc/withHoverIcon';
import { DpdgIcon } from '../../icons/dpdg';
import { FaceSmile } from '../../icons/face-smile';
import { QuestionIcon } from '../../icons/question';
import { MacIcon } from '../../icons/mac';
import { WheelIcon } from '../../icons/wheel';
import { ColorCodeIcon } from '../../icons/color-сode';
import { CloudsIcon } from '../../icons/clouds';
import { GrowAiIcon } from '../../icons/grow-ai';
import { SandTherapyIcon } from '../../icons/sand-therapy';

import { useTariffToolCheck } from '../../../hooks/useTariffToolCheck';

import { withOverlayIcon } from '../../../hoc/withOverlayIcon';
import { Lock } from '../../icons/lock';

import { Pressable } from '../../../shared/ui';

import { PsyToolsId, toolNamesMap } from './types';

const DpdgIconWithHover = withHoverIcon(DpdgIcon);
const FaceSmileWithHover = withHoverIcon(FaceSmile);
const MacIconWithHover = withHoverIcon(MacIcon);
const QuestionIconWithHover = withHoverIcon(QuestionIcon);
const WheelIconWithHover = withHoverIcon(WheelIcon);
const СolorCodeWithHover = withHoverIcon(ColorCodeIcon);
const CloudsIconWithHover = withHoverIcon(CloudsIcon);
const GrowAiIconWithHover = withHoverIcon(GrowAiIcon);
const SandTherapyIconWithHover = withHoverIcon(SandTherapyIcon);

const DpdgIconWithLock = withOverlayIcon(DpdgIcon, Lock);
const FaceSmileWithLock = withOverlayIcon(FaceSmile, Lock);
const MacIconWithLock = withOverlayIcon(MacIcon, Lock);
const QuestionIconWithLock = withOverlayIcon(QuestionIcon, Lock);
const WheelIconWithLock = withOverlayIcon(WheelIcon, Lock);
const СolorCodeWithLock = withOverlayIcon(ColorCodeIcon, Lock);
const CloudsIconWithLock = withOverlayIcon(CloudsIcon, Lock);
const GrowAiIconWithLock = withOverlayIcon(GrowAiIcon, Lock);
const SandTherapyIconWithLock = withOverlayIcon(SandTherapyIcon, Lock);

export interface IButtonTool {
  thisMenuId: PsyToolsId | 0;
  curMenuId?: PsyToolsId | 0;
  disabled: boolean;
  selected: boolean;
  onSetMenu: (num: PsyToolsId | 0) => void;
}
const tooltipText = 'Инструмент доступен на других тарифных планах. Подробнее в разделе «Тарифы»';

export const ButtonTool = ({ thisMenuId, selected, disabled, onSetMenu }: IButtonTool) => {
  const toolName = toolNamesMap[thisMenuId];
  const isActiveByTariff = useTariffToolCheck(toolName);
  const isButtonDisabled = disabled || !isActiveByTariff;

  const colorPropsRegular = useMemo(() => {
    return {
      defaultFill: '#fff',
      defaultFillBg: '#828282',
      hoverFill: '#fff', // Цвет при наведении
      hoverFillBg: '#111026', // Цвет фона при наведении})
    };
  }, []);

  const colorPropsSelected = useMemo(() => {
    return {
      defaultFill: '#828282',
      defaultFillBg: '#DEC05E',
      hoverFill: '#828282', // Цвет при наведении
      hoverFillBg: '#DEC05E',
    };
  }, []);

  const classButtonTool = classNames('w-auto p-0', {
    'cursor-pointer': !isButtonDisabled,
    'cursor-not-allowed': isButtonDisabled,
  });

  const propsIco = selected ? colorPropsSelected : colorPropsRegular;

  const toolIco = useCallback(() => {
    switch (thisMenuId) {
      case PsyToolsId.EMOTIONS:
        return isActiveByTariff ? (
          <FaceSmileWithHover disabled={disabled} {...propsIco} />
        ) : (
          <FaceSmileWithLock
            overlayProps={{ width: 18, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            // disabled={disabled}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );
      case PsyToolsId.MAC_CARDS:
        return isActiveByTariff ? (
          <MacIconWithHover disabled={disabled} {...propsIco} />
        ) : (
          <MacIconWithLock
            overlayProps={{ width: 18, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            // disabled={disabled}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );
      case PsyToolsId.QUESTION:
        return isActiveByTariff ? (
          <QuestionIconWithHover disabled={disabled} {...propsIco} />
        ) : (
          <QuestionIconWithLock
            overlayProps={{ width: 18, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            // disabled={disabled}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );
      case PsyToolsId.DPDG:
        return isActiveByTariff ? (
          <DpdgIconWithHover disabled={disabled} {...propsIco} />
        ) : (
          <DpdgIconWithLock
            overlayProps={{ width: 18, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            // disabled={disabled}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );
      case PsyToolsId.WHEEL:
        return isActiveByTariff ? (
          <WheelIconWithHover disabled={disabled} {...propsIco} classNameRect="" />
        ) : (
          <WheelIconWithLock
            overlayProps={{ width: 18, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            // disabled={disabled}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );
      case PsyToolsId.COLOR_CODE:
        return isActiveByTariff ? (
          <СolorCodeWithHover disabled={disabled} {...propsIco} />
        ) : (
          <СolorCodeWithLock
            overlayProps={{ width: 28, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );
      case PsyToolsId.CLOUDS:
        return isActiveByTariff ? (
          <CloudsIconWithHover disabled={disabled} {...propsIco} />
        ) : (
          <CloudsIconWithLock
            overlayProps={{ width: 18, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );
      case PsyToolsId.GROW:
        return isActiveByTariff ? (
          <GrowAiIconWithHover disabled={disabled} {...propsIco} />
        ) : (
          <GrowAiIconWithLock
            overlayProps={{ width: 18, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );

      case PsyToolsId.SAND_THERAPY:
        return isActiveByTariff ? (
          <SandTherapyIconWithHover disabled={disabled} {...propsIco} />
        ) : (
          <SandTherapyIconWithLock
            overlayProps={{ width: 18, height: 18, fill: '#C0C0C0' }}
            {...propsIco}
            fill={'#C0C0C0'}
            offsetX={'40%'}
            offsetY={'-40%'}
            tooltip={tooltipText}
          />
        );

      default:
        return <></>;
    }
  }, [disabled, isActiveByTariff, propsIco, thisMenuId]);

  return (
    <Pressable
      key={`btn-${thisMenuId}`}
      onClick={() => onSetMenu(thisMenuId)}
      disabled={isButtonDisabled}
      className={classButtonTool}
    >
      {toolIco()}
    </Pressable>
  );
};
